import { useTranslation } from 'react-i18next'
import { StyleSheet } from 'react-native'
import { WorkspaceTypeSpecification } from 'zens-store'
import { Text, TextProps } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    lineHeight: 16,
  },
})

interface Props extends TextProps {
  value: WorkspaceTypeSpecification
}

const Specification = (props: Props) => {
  const { value, style, children, ...otherProps } = props
  const { t } = useTranslation()

  const titleForValue = (value: WorkspaceTypeSpecification) => {
    switch (value) {
      case WorkspaceTypeSpecification.CoWorking:
        return t('Co-working')
      case WorkspaceTypeSpecification.SoundProof:
        return t('Sound-proof')
    }
  }

  return (
    <Text style={[styles.container, style]} {...otherProps}>
      {titleForValue(value)}
      {children}
    </Text>
  )
}

export default Specification
